import { PropTypes } from 'prop-types'

const replaceInternalLinks = (el, isLocal) => {
  const someElement = window.document.createElement('div')
  someElement.innerHTML = el.value
  const results = someElement.querySelectorAll('a[data-type="internal"]')
  Array.from(results).map(
    (a) =>
      (a.pathname = isLocal
        ? `/site/blogspa${a.pathname}`
        : `/insights/latest-insights${a.pathname}`)
  )
  return {
    ...el,
    value: someElement.innerHTML,
  }
}

replaceInternalLinks.PropTypes = {
  el: PropTypes.shape({
    contentType: PropTypes.string,
    value: PropTypes.string,
  }),
  isLocal: PropTypes.bool,
}
export { replaceInternalLinks }
